import React from 'react'

const NotFoundPage = () => {
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      <h3>i am 404 page</h3>
    </div>
  )
}

export default NotFoundPage
